<template>
    <div style="overflow: hidden;width: 100%">
        <div class="handle">
            <div class="container">
                <a-row>
                    <a-col :span="24">
                        <a class="logo" href="">
                            <img src="../../img/logo2.png">
                            <!--<p>广东省环境监测中心阳光快采平台</p>-->
                        </a>
                        <div class="right size5"  >
                            <a-tooltip placement="bottom" >
                                <div slot="title">
                                    <span>首页</span>
                                </div>
                                <a class="color-ash" href="" style="cursor: pointer;">
                                    <a-icon type="home"  />
                                </a>
                            </a-tooltip>
                            <a-tooltip placement="bottom" @click="onHelp">
                                <div slot="title" >
                                    <span>帮助</span>
                                </div>
                                <a class="color-ash" style="cursor: pointer;">
                                    <a-icon type="question-circle"/>
                                </a>
                            </a-tooltip>
                            <a-tooltip placement="bottom">
                                <div slot="title">
                                    <span>退出登录</span>
                                </div>
                                <a class="color-ash" href="javascript:;" @click="handleLogout" style="cursor: pointer;">
                                    <a-icon type="poweroff" />
                                </a>
                            </a-tooltip>
                            <span class="size2 color-ash ml-5 mr-2 pl-5 border-left" style="cursor: pointer;" @click="onPerson">{{userName}}</span>
                            <a-avatar icon="user" @click="onPerson" />
<!--                            <a-tooltip class="mr-6" placement="bottom">-->
<!--                                <a href="javascript:;" @click="personCenter"  v-if="userName">{{userName}}</a>-->
<!--                            </a-tooltip>-->
                        </div>
                    </a-col>
                </a-row>
            </div>
        </div>
        <div style="height: 56px;"></div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'

    export default {
        created() {
            this.userName = this.$store.getters.nickname
            console.log(this.$store.getters.token);
        },
        mounted() {
            this.timer = setInterval(this.countDown, 1000)
        },
        data() {
            return {
                userName: '',
                orgName: '',
                actions: [
                    {type: 'bank', text: '广东省环境监测中心'},
                    {type: 'clock-circle', text: '发布时间：今天10: 30 '},
                ]
            }
        },
        methods: {
            ...mapActions(['Logout']),
            ...mapGetters(['nickname', 'avatar']),
            handleLogout() {
                const that = this
                this.$confirm({
                    title: '提示',
                    content: '真的要注销登录吗 ?',
                    onOk() {
                        return that.Logout({}).then(() => {
                        }).catch(err => {
                            that.$message.error({
                                title: '错误',
                                description: err.message
                            })
                        })
                    },
                    onCancel() {
                    }
                })
            },
            personCenter() {
                this.$router.push({path:'/account/AccountManage'})
            },
            onHelp() {
                this.$router.push({path:'/message/SysHelp'})
            },
            onPerson() {
                this.$router.push({path:'/account/AccountManage'})
            }
        }
    }
    ;
</script>
<style lang="less" scoped>
    .handle .right a{
        margin-left: 30px;
    }
</style>
